// This client was automatically generated by Segment Typewriter. ** Do Not Edit **
// To update this file, run:
//   npx typewriter
//

export enum OpeningMethod {
  DefaultAtLaunch = 'defaultAtLaunch',
  FromStorePage = 'fromStorePage',
  UserSwitch = 'userSwitch',
}

/**
 * L’event “App Update Completed” est un event qui sera déclenché à la fin de l'update
 * automatique (fin de l'installation) de l'application locale. Il nous permettra de suivre
 * l'avancement du déploiement des updates.
 */
export interface AppUpdateCompleted {
  desktopVersion?: string;
  webVersion?: string;
  [property: string]: any;
}

/**
 * L’event “App Update Failed” est un event qui sera déclenché lorsqu’une erreur a
 * interrompu le process d’update.
 */
export interface AppUpdateFailed {
  /**
   * version de l'app locale avant la tentative de mise à jour
   */
  desktopVersion?: string;
  errorCause?: string;
  webVersion?: string;
  [property: string]: any;
}

/**
 * L’event “App Update Started” est un event qui sera déclenché lors du début de l'update
 * automatique (lancement du téléchargement) de l'application locale.  Il nous permettra de
 * suivre l'avancement du déploiement des updates.
 */
export interface AppUpdateStarted {
  /**
   * version de l'app locale avant la mise à jour
   */
  desktopVersion?: string;
  webVersion?: string;
  [property: string]: any;
}

/**
 * Click sur "selectionner" le patient dans les résultats de la recherche patient
 */
export interface ApplyPatientResult {
  /**
   * position du patient selectionné dans les résultats de la recherche
   */
  resultPosition?: string;
  /**
   * dépendant du contexte où la recherche est utilisée, targetId correspond à un id de
   * document
   */
  targetId?: string;
  [property: string]: any;
}

/**
 * Envoyé lorsque l'utilisateur clique sur un bouton qui permet de faire une action groupée.
 */
export interface BatchActionClicked {
  /**
   * Permet de distinguer le type de l'action cliquée par l'utilisateur
   */
  actionType: BatchActionClickedActionType;
  /**
   * Identifiants FHIR des documents sélectionnés
   */
  documentIds?: any[];
  numberOfSelectedRows: number;
  [property: string]: any;
}

/**
 * Permet de distinguer le type de l'action cliquée par l'utilisateur
 */
export enum BatchActionClickedActionType {
  AddToPendingFolder = 'add_to_pending_folder',
  Archive = 'archive',
  Delete = 'delete',
  Download = 'download',
  Duplicate = 'duplicate',
  Group = 'group',
  Integrate = 'integrate',
  RemoveFromPendingFolder = 'remove_from_pending_folder',
  Restore = 'restore',
  Send = 'send',
  Split = 'split',
  Unknown = 'unknown',
  Validate = 'validate',
}

/**
 * When a user submits a bulk update on selected documents
 */
export interface BatchDocumentsModified {
  /**
   * number of documents to be updated
   */
  documents: number;
  /**
   * the title to apply to all the selected documents
   */
  documentTitle?: boolean;
  /**
   * the type to apply to selected documents
   */
  documentType?: string;
  [property: string]: any;
}

/**
 * Comment le document a-t-il été uploadé ?
 */
export enum BatchFileUploadStartSource {
  Button = 'button',
  DragDrop = 'drag&drop',
  LifenServer = 'lifenServer',
  Opening = 'opening',
  Outbox = 'outbox',
}

export interface CancelDocumentsSending {
  documentIds: any[];
  [property: string]: any;
}

export interface CloseEnsConversation {
  closed?: boolean;
  documentId?: string;
  [property: string]: any;
}

export enum ContactType {
  All = 'all',
  Favorites = 'favorites',
  Organization = 'organization',
  Practitioner = 'practitioner',
}

export interface CustomEnsMessageAdded {
  documentId?: string;
  isEmpty?: boolean;
  [property: string]: any;
}

export interface DashboardFiltered {
  dashboardType?: string;
  dateRange?: { [key: string]: any };
  defaultDateRange?: boolean;
  documentTypeFiltered?: string;
  /**
   * When the dashboard is filtered to display only documents created/imported by the user
   */
  hideOtherRequesters?: boolean;
  idFiltered?: string;
  mediumFiltered?: string;
  page?: number;
  patientAdvancedFiltered?: any[];
  patientFiltered?: boolean;
  /**
   * Maximum number of documents displayed per page
   */
  perPage?: number;
  recipient?: string;
  servicesFiltered?: string;
  signingPractitionerFiltered?: string;
  /**
   * When a dashboard is filtered by source of the document (Lifen integration only)
   */
  sourceFiltered?: string;
  statusFiltered?: string;
  /**
   * How many filters the user keeps in the filter bar (customizable filter bar only)
   */
  visibleFilterCount?: number;
  [property: string]: any;
}

export interface DashboardSorted {
  dashboardType?: string;
  sortBy?: string;
  sortDirection?: string;
  [property: string]: any;
}

export enum PanelType {
  Organizations = 'organizations',
  Practitioners = 'practitioners',
}

export interface DocumentForwardToLifenDocumentModified {
  forwardToLifenDocument?: boolean;
  [property: string]: any;
}

export interface DocumentActionClicked {
  actionType?: DocumentActionClickedActionType;
  communicationRequest?: string;
  [property: string]: any;
}

export enum DocumentActionClickedActionType {
  Archive = 'archive',
  Delete = 'delete',
  Download = 'download',
  Duplicate = 'duplicate',
  Forward = 'forward',
  Integrate = 'integrate',
  Restore = 'restore',
  Send = 'send',
  Split = 'split',
  Unknown = 'unknown',
}

export interface DocumentDatePeriodModified {
  newEndDate?: string;
  newStartDate?: string;
  previousEndDate?: string;
  previousStartDate?: string;
  [property: string]: any;
}

/**
 * L'event "Document Id Copied" est envoyé lorsqu'un utilisateur clic sur le bouton pour
 * copier l'id du document
 */
export interface DocumentIDCopied {
  fhirReference?: string;
  [property: string]: any;
}

export interface DocumentIntegrated {
  documentType?: string;
  isBatchAction: boolean;
  medicalVisaNeeded?: boolean;
  numberOfItemInBatch?: number;
  /**
   * source corresponds to the document source, which can be LIFEN INTEGRATION or LIFEN
   * INTEGRATION FORWARD.
   */
  source?: string;
  [property: string]: any;
}

/**
 * When the user clicks to go to the previous or next document
 */
export interface DocumentNavigatorClicked {
  dashboardType?: string;
  /**
   * navigation = next if the user go to the next document / navigation = previous if the user
   * go to previous document
   */
  navigation?: string;
  [property: string]: any;
}

export interface DocumentPrinted {
  fhirReference?: string;
  [property: string]: any;
}

export interface DocumentSenderModified {
  newSender?: string;
  previousSender?: string;
  [property: string]: any;
}

export interface DocumentSpecialityModified {
  newSpeciality?: string;
  previousSpeciality?: string;
  [property: string]: any;
}

/**
 * L'event "Document Title Modified" est utilisé dans Lifen intégration lorsque
 * l'utilisateur modifie le titre via le bouton reset ou l'input text
 */
export interface DocumentTitleModified {
  isDefaultTitle: boolean;
  [property: string]: any;
}

export interface DocumentTypeModified {
  communicationRequest?: string;
  desktopVersion?: string;
  newType?: string;
  previousType?: string;
  webVersion?: string;
  [property: string]: any;
}

export interface DraftDashboardIdentityNavigationLinkClicked {
  /**
   * identity reference
   */
  identity: string;
  [property: string]: any;
}

/**
 * L'upload du document a échoué
 */
export interface FileUploadFailed {
  /**
   * Cause de l'erreur
   */
  errorCause?: string;
  [property: string]: any;
}

export enum Context {
  App = 'app',
  Web = 'web',
}

export enum Platform {
  Desktop = 'desktop',
  Mobile = 'mobile',
  Tablet = 'tablet',
}

export interface GroupedDocumentReordered {
  fhirReference?: string;
  [property: string]: any;
}

export interface ImportModalExpanded {
  total_documents?: number;
  [property: string]: any;
}

export interface InErrorsDashboardFiltered {
  filename?: string;
  fromDate?: Date;
  id?: string;
  message_contains?: string;
  patientFiltered?: boolean;
  untilDate?: Date;
  [property: string]: any;
}

export interface IntegrationMatchDone {
  fhirReference?: string;
  [property: string]: any;
}

/**
 * Cet event est envoyé lorsque le dashboard de l'application Visa Médecin est filtré
 */
export interface MedicalVisaDashboardFiltered {
  documentType?: string;
  orderBy?: string;
  orderDirection?: string;
  page?: number;
  pageSize?: number;
  status?: string;
  [property: string]: any;
}

/**
 * When a user signs a medical visa
 */
export interface MedicalVisaSigned {
  documentType?: string;
  withComment?: boolean;
  [property: string]: any;
}

export interface MessageSent {
  communicationRequest?: string;
  currentWorkspaceFhirName?: string;
  currentWorkspaceFhirReference?: string;
  deliveredToPatient?: DeliveredToPatient;
  dematPatient?: boolean;
  desktopVersion?: string;
  dmpIntegration?: DmpIntegration | null;
  documentLoincType?: string;
  dpiIntegration?: DPIIntegration;
  /**
   * Référence de la ressource en question, avec le type de la resource:
   * CommunicationRequest/123, Communication/123
   */
  fhirReference?: string;
  includeMessageText?: boolean;
  isAutonomous?: boolean;
  /**
   * L'action a été déclenchée en Batch
   */
  isBatchAction?: boolean;
  /**
   * Est-ce que le doc est issu de publipostage ?
   */
  isDirectMail?: boolean;
  /**
   * Le message envoyé est-il un message groupé ?
   */
  isGrouped?: string;
  /**
   * Nombre de caractères du message associé à l'envoi
   */
  messageTextLength?: number;
  quickviewRecipientAmount?: number;
  requesterFhirReference?: string;
  requesterName?: string;
  senderFhirReference?: string;
  senderName?: string;
  /**
   * l'ID du Thread dans notre DB  (lifen mail)
   */
  threadId?: string;
  /**
   * l'ID du message dans notre DB (lifen mail)
   */
  threadItemId?: string;
  webVersion?: string;
  workspaceFhirReference?: string;
  [property: string]: any;
}

export enum DeliveredToPatient {
  Demat = 'demat',
  DematAndPaper = 'dematAndPaper',
  False = 'false',
  Paper = 'paper',
}

export enum DmpIntegration {
  Selected = 'selected',
  Unselected = 'unselected',
}

export enum DPIIntegration {
  Auto = 'auto',
  Manual = 'manual',
  Unselected = 'unselected',
}

export interface NewDematRecipientFormMatchExistingEmail {
  email?: string;
  nbResults?: number;
  type?: string;
  [property: string]: any;
}

export interface NewDematRecipientFormSubmitExistingEmail {
  type?: string;
  [property: string]: any;
}

/**
 * Soumission du formulaire d'ajout manuelle de destinataire avec une adresse
 * mail/MSS/Apicrypt
 */
export interface NewDematRecipientFormSubmitted {
  address_type: AddressType;
  [property: string]: any;
}

export enum AddressType {
  Apicrypt = 'apicrypt',
  Email = 'email',
  Mssante = 'mssante',
}

export interface PatientAdded {
  patientId?: string;
  [property: string]: any;
}

/**
 * lorsque l’on créé un nouveau patient dans la vue de détail d’une CR depuis la modale
 * patient
 *
 * lorsque l’on créé un nouveau patient pour l’ajouter en tant que recipient depuis la
 * modale d’ajout de destinataire
 */
export interface PatientCreated {
  desktopVersion?: string;
  fhirReference?: string;
  hasNir?: boolean;
  webVersion?: string;
  [property: string]: any;
}

export interface PatientMatchRelaunched {
  /**
   * matchStatus corresponds to the patient's match status preceding the user's action
   */
  matchStatus?: string;
  [property: string]: any;
}

export interface PatientModifyClicked {
  /**
   * matchStatus corresponds to the patient's match status preceding the user's action
   */
  matchStatus?: string;
  [property: string]: any;
}

export interface PatientRemoved {
  /**
   * matchStatus corresponds to the patient's match status preceding the user's action
   */
  matchStatus?: string;
  patientId?: string;
  [property: string]: any;
}

export interface PatientUpdated {
  desktopVersion?: string;
  /**
   * true if edition from patient recipient
   */
  editedFromRecipient?: boolean;
  hasNir?: boolean;
  /**
   * matchStatus corresponds to the patient's match status preceding the user's action
   */
  matchStatus?: string;
  patientId?: string;
  updatedBy?: string;
  updatedInformation?: any[];
  webVersion?: string;
  [property: string]: any;
}

export interface PDFEditorPageViewed {
  source?: string;
  [property: string]: any;
}

/**
 * Click sur "rechercher" dans la recherche patient
 */
export interface SearchPatientStarted {
  /**
   * Liste des champs dont la valeur a été renseignée par l'IA
   */
  AiPrefilledFields?: any[];
  /**
   * Liste des champs de recherche renseignés
   */
  filledFields?: any[];
  /**
   * Dépendant du contexte où est utilisée la recherche, targetId correspond à un document id
   */
  targetId?: string;
  [property: string]: any;
}

/**
 * Envoyé lorsque l'utilisateur change l'émetteur dans le dropdown Prochains envois
 */
export interface SelectedIdentityUpdated {
  newSelectedIdentity?: string;
  [property: string]: any;
}

/**
 * Envoyé lorsque l'utilisateur clique sur les CTA Valider/Remplacer/Supprimer le
 * destinataire d'une vérification
 */
export interface VerificationAction {
  actionType?: string;
  dismissedAt?: string;
  notCertainCase?: string;
  verifiableId?: string;
  verifiableType?: string;
  verificationId?: string;
  verificationKey?: string;
  [property: string]: any;
}
